import React, { useEffect, useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { message, Spin, Popconfirm, Select, Tag, Input } from "antd";
import Instance from "../../AxiosConfig";
import "./Users.css";
import { LuUserRound } from "react-icons/lu";
import { MdDeleteOutline, MdModeEditOutline } from "react-icons/md";
const { Option } = Select;

const Users = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);

  const [showModal, setShowModal] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [selectedId, setSelectedId] = useState("");

  const initialState = {
    userName: "",
    userEmail: "",
    userPassword: "",
    userPhoneNumber: "",
    role: "",
  };

  const [formData, setFormData] = useState(initialState);

  useEffect(() => {
    fetchUsers();
  }, []);

  const fetchUsers = async () => {
    try {
      setLoading(true);

      const res = await Instance.get("/users");
      console.log(res, "users data");
      setUsers(res?.data?.users || []);
    } catch (err) {
      console.log(err);
      message.error("Failed to fetch users");
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setShowModal(false);
    setIsEdit(false);
    setSelectedId("");
    setFormData(initialState);
  };

  const handleShow = () => {
    setIsEdit(false);
    setSelectedId("");
    setFormData(initialState);
    setShowModal(true);
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleRoleChange = (value) => {
    setFormData({
      ...formData,
      role: value,
    });
  };

  const validateForm = () => {
    if (!formData.userName.trim()) {
      message.error("User Name is required");
      return false;
    }

    if (!formData.userEmail.trim()) {
      message.error("Email is required");
      return false;
    }

    const emailRegex = /^\S+@\S+\.\S+$/;

    if (!emailRegex.test(formData.userEmail)) {
      message.error("Invalid email");
      return false;
    }

    if (!isEdit) {
  if (!formData.userPassword.trim()) {
    message.error("Password is required");
    return false;
  }

  if (formData.userPassword.length < 6) {
    message.error("Password must be at least 6 characters");
    return false;
  }
}

    if (!formData.userPhoneNumber.trim()) {
      message.error("Phone Number is required");
      return false;
    }

    const phoneRegex = /^\d{10}$/;

    if (!phoneRegex.test(formData.userPhoneNumber)) {
      message.error("Phone Number must be 10 digits");
      return false;
    }

    if (!formData.role) {
      message.error("Role is required");
      return false;
    }

    return true;
  };

  const handleEdit = (user) => {
    setIsEdit(true);
    setSelectedId(user._id);

    setFormData({
      userName: user.userName,
      userEmail: user.userEmail,
      userPassword: "",
      userPhoneNumber: user.userPhoneNumber,
      role: user.role,
    });

    setShowModal(true);
  };

  const handleSave = async () => {
    if (!validateForm()) return;

    try {
      setLoading(true);

      if (isEdit) {
        const payload = {
          userName: formData.userName,
          userEmail: formData.userEmail,
          userPhoneNumber: formData.userPhoneNumber,
          role: formData.role,
        };
        await Instance.put(`/users/${selectedId}`, payload);

        message.success("User updated successfully");
      } else {
        await Instance.post("/users", formData);

        message.success("User created successfully");
      }

      handleClose();
      fetchUsers();
    } catch (err) {
      console.log(err);
      message.error(err?.response?.data?.message || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    try {
      setLoading(true);

      await Instance.delete(`/users/${id}`);

      message.success("User deleted successfully");

      fetchUsers();
    } catch (err) {
      console.log(err);
      message.error("Delete failed");
    } finally {
      setLoading(false);
    }
  };
  return (
    <div className="admin-users-wrapper">
      <div className="admin-users-header">
        <h2>Users</h2>

        <Button variant="primary" onClick={handleShow}>
          + Create User
        </Button>
      </div>

      <Spin spinning={loading}>
        <div className="admin-users-grid row">
          {users.length > 0 ? (
            users.map((user) => (
              <div className=" col-lg-4" key={user._id}>
                <div className="admin-user-card " key={user._id}>
                  <div className="admin-user-actions">
                    <Button
                      variant="warning"
                      size="sm"
                      onClick={() => handleEdit(user)}
                    >
                      <MdModeEditOutline />
                    </Button>

                    <Popconfirm
                      title="Delete User"
                      description="Are you sure you want to delete this user?"
                      okText="Yes"
                      cancelText="No"
                      onConfirm={() => handleDelete(user._id)}
                    >
                      <Button variant="danger" size="sm">
                        <MdDeleteOutline />
                      </Button>
                    </Popconfirm>
                  </div>
                  <div className="admin-user-avatar">
                    <LuUserRound />
                  </div>

                  <h4>{user.userName}</h4>

                  <p>{user.userEmail}</p>

                  <p>{user.userPhoneNumber}</p>

                  <p>
                    <strong>Role :</strong>{" "}
                    <Tag
                      color={user.role === "admin" ? "blue" : "green"}
                      style={{ fontSize: "18px" }}
                    >
                      {user.role.charAt(0).toUpperCase() + user.role.slice(1)}
                    </Tag>
                  </p>
                </div>
              </div>
            ))
          ) : (
            <div className="admin-no-users">No users found</div>
          )}
        </div>
      </Spin>

      <Modal show={showModal} onHide={handleClose} centered backdrop="static">
        <Modal.Header closeButton>
          <Modal.Title>{isEdit ? "Edit User" : "Create User"}</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Form>
            <Form.Group className="mb-3">
              <Form.Label>
                User Name <span className="required-field">*</span>
              </Form.Label>

              <Form.Control
                type="text"
                name="userName"
                value={formData.userName}
                onChange={handleChange}
                placeholder="Enter User Name"
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>
                Email <span className="required-field">*</span>
              </Form.Label>

              <Form.Control
                type="email"
                name="userEmail"
                value={formData.userEmail}
                onChange={handleChange}
                placeholder="Enter Email"
              />
            </Form.Group>
           {!isEdit && (
  <Form.Group className="mb-3">
    <Form.Label>
      Password <span className="required-field">*</span>
    </Form.Label>

    <Input.Password
      name="userPassword"
      value={formData.userPassword}
      placeholder="Enter Password"
      onChange={handleChange}
    />
  </Form.Group>
)}

            <Form.Group className="mb-3">
              <Form.Label>
                Phone Number <span className="required-field">*</span>
              </Form.Label>

              <Form.Control
                type="text"
                name="userPhoneNumber"
                value={formData.userPhoneNumber}
                onChange={handleChange}
                maxLength={10}
                placeholder="Enter Phone Number"
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>
                Role <span className="required-field">*</span>
              </Form.Label>
              <Select
                style={{ width: "100%" }}
                value={formData.role || undefined}
                placeholder="Select Role"
                onChange={handleRoleChange}
              >
                <Option value="manager">Manager</Option>
                <Option value="admin">Admin</Option>
              </Select>
            </Form.Group>
          </Form>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Cancel
          </Button>

          <Button variant="primary" onClick={handleSave}>
            {isEdit ? "Update User" : "Create User"}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default Users;
